import { computed, ref } from 'vue';
import { axiosGetFailsWithError } from '@/vue/utils/api';
export var UserRole;
(function (UserRole) {
    UserRole["Admin"] = "admin";
    UserRole["Support"] = "support";
    UserRole["ProjectSupport"] = "project_support";
    UserRole["ZoneManager"] = "zone_manager";
    UserRole["Manager"] = "manager";
    UserRole["User"] = "user";
    UserRole["Scout"] = "scout";
    UserRole["Reader"] = "reader";
})(UserRole || (UserRole = {}));
export const getUserRole = async (apiBase) => {
    try {
        return await axiosGetFailsWithError(`${apiBase}/api/private/user/v1/info/me`);
    }
    catch (e) {
        return Promise.reject(e);
    }
};
// TODO: Improve cache to use session storage once we move to SPA and can remove it once user clicks logout
let cachedRole;
export const setCachedRole = (role) => {
    cachedRole = role;
};
export const isRoleLowerThanManager = (role) => role === UserRole.User || role === UserRole.Reader || role === UserRole.Scout;
export const isRoleManagerOrAbove = (role) => role === UserRole.ZoneManager || role === UserRole.Manager || isRoleProjectSupportOrAbove(role);
export const isRoleProjectSupportOrAbove = (role) => role === UserRole.Admin || role === UserRole.Support || role === UserRole.ProjectSupport;
export const isRoleProjectSupport = (role) => role === UserRole.ProjectSupport;
export const isRoleAdminOrSupport = (role) => role === UserRole.Admin || role === UserRole.Support;
export const isRoleAdmin = (role) => role === UserRole.Admin;
export function useUserRole() {
    const apiBase = '/' + location.pathname.split('/')[1];
    const role = ref(UserRole.Reader);
    const roleLoading = ref(false);
    let getUserRolePromise = new Promise(() => role.value);
    if (cachedRole) {
        role.value = cachedRole;
    }
    else if (!roleLoading.value) {
        roleLoading.value = true;
        getUserRolePromise = getUserRole(apiBase)
            .then((response) => {
            setCachedRole(response.role);
            role.value = response.role;
            return response.role;
        })
            .finally(() => (roleLoading.value = false));
    }
    const isAdmin = computed(() => isRoleAdmin(role.value));
    const isAdminOrSupport = computed(() => isRoleAdminOrSupport(role.value));
    const isProjectSupportOrAbove = computed(() => isRoleProjectSupportOrAbove(role.value));
    const isProjectSupport = computed(() => isRoleProjectSupport(role.value));
    const isManagerOrAbove = computed(() => isRoleManagerOrAbove(role.value));
    const isLowerThanManager = computed(() => isRoleLowerThanManager(role.value));
    return {
        roleLoading,
        role,
        isAdmin,
        isAdminOrSupport,
        isManagerOrAbove,
        isProjectSupport,
        isProjectSupportOrAbove,
        isLowerThanManager,
        getUserRolePromise,
    };
}
